/**
 * A line of the remuneration cards, as on the prototype: what it is, its
 * value in bold, then what it says in words. `onOpen` makes the whole line
 * open its editor; `trailing` sits at its right (an alert, a bin). A value
 * with no text (a day's name) takes the text's room too.
 */
const RemunerationRow = ({
  label,
  value,
  text,
  onOpen,
  trailing,
  rowRef,
  className = '',
}) => {
  const content = (
    <>
      <span className="truncate text-gray-600">{label}</span>
      {text ? (
        <>
          <span className="whitespace-nowrap font-medium text-gray-900">
            {value}
          </span>
          <span className="min-w-0 truncate text-gray-600">{text}</span>
        </>
      ) : (
        <span className="col-span-2 min-w-0 truncate font-medium text-gray-900">
          {value}
        </span>
      )}
      <span className="flex items-center justify-end gap-2">{trailing}</span>
    </>
  );
  const layout = `grid w-full grid-cols-[190px_80px_minmax(0,1fr)_auto] items-center gap-2 px-4 py-2.5 text-left ${className}`;
  if (!onOpen)
    return (
      <div ref={rowRef} className={layout}>
        {content}
      </div>
    );
  // A div with the button role: `trailing` may hold a button of its own.
  return (
    <div
      ref={rowRef}
      role="button"
      tabIndex={0}
      onClick={onOpen}
      onKeyDown={(event) => {
        if (
          event.target !== event.currentTarget ||
          (event.key !== 'Enter' && event.key !== ' ')
        )
          return;
        event.preventDefault();
        onOpen();
      }}
      className={`${layout} cursor-pointer transition-colors hover:bg-gray-50`}
    >
      {content}
    </div>
  );
};

export default RemunerationRow;
